type Translation = {
  translation: any;
};

/** 语言别名 */
const alias: Record<string, string> = {
  "zh-Hans": "zh-CN",
  "zh-Hant": "zh-HK",
  "zh-HK": "zh-TW",
  "zh": "zh-CN",
  "en": "en-US",
  "de": "de-DE",
  "es": "es-ES",
};

const context = (require as any).context("./lang", false, /\.json$/);

const translations: Record<string, Translation> = {};

context.keys().forEach((fileName: string) => {
  const locale = fileName.match(/\.\/(.*)\.json$/)?.[1];
  if (locale) {
    translations[locale] = {
      translation: context(fileName),
    };
    if (locale.includes("-") && locale.split("-")[0]) {
      translations[locale.split("-")[0]] = {
        translation: context(fileName),
      };
    }
  }
});

if (Object.keys(alias).length) {
  Object.keys(alias).forEach((key) => {
    translations[key] = translations[alias[key]];
  });
}

export default translations;
